/**
 * System Reducers
 */
import { combineReducers } from "redux";
import NotificationReducer from "./notification-reducer";
import ErrorNotificationReducer from "./error-notification-reducer";
import UserProfileReducer from "./user-profile-reducer";

/**
 * System functionalities
 */
const SystemReducer = combineReducers({
  notification: NotificationReducer,
  errorNotification: ErrorNotificationReducer,
  userProfile: UserProfileReducer,
});

export default SystemReducer;
